// extracted by mini-css-extract-plugin
export default {"base":"vp_qvV2B","label":"vp_vCCg3","value":"vp_aMYP7","alignRight":"vp_QLTvo","compact":"vp_Zzkrf","horizontal":"vp_rbD9w","wrap":"vp_UGQyc"};